import { Controller } from './controller'

export enum STATION_STATE_NAME {
  ERROR = 'Error',
  WAIT_SCHEDULE = 'Wait Schedule',
  WAIT_START = 'Wait Start',
  IDLING = 'Idling',
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  WAIT_STOP = 'Wait Stop',
  SOAKING = 'Soaking',
  RAIN_SOAKING = 'Rain Soaking',
}

export interface STATION_DETAIL {
  id: number
  address: number
  controllerId: number
  description: string
  interfaceId: number
  pictureUrl: string
  pictureFileName: string
  priority: number
  grsCoordinatedLatitude: number
  grsCoordinatedLongitude: number
  waterRequired: number
  surfaceAccumulation: number
  plantAvailWater: number
  precipitationRate: number
  expectedFlow: number
  landscapeFactor: number
  rtDayOverride: number
  lastUpdate: string
  lastETUpdate: string
  controller: Controller
  emitter: string
  plant: string
  pipe: string
  soil: string
  areaSubArea: string
  etZone: {
    id: number
    interfaceId: number
    name: string
    etNumber: number
  }
  marker: STATION_DETAIL_MARKER
  floorId: number
  type?: string | number | null
}

export interface STATION_DETAIL_MARKER {
  id: number
  name: string
  imageUrl: string
  s3Url: string
}
